import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Enlightenment_&_Revolutions_-_Latin_American_Wars_of_Independence.png';

function HistoryPageLatinAmericanWarsGo() {
  return (
    <QuizPage
      title="History: Latin American Wars of Independence"
      subTopic="Latin American Wars of Independence"
      backgroundImage={historyImage}
      returnPath="/History-Latin-American-Wars"
    />
  );
}

export default HistoryPageLatinAmericanWarsGo;
